import { stepLabel } from '@/lib/format'
import type { WorkflowStep } from '@/types/dashboard'

export function StepRail({ steps }: { steps: WorkflowStep[] }) {
  if (!steps.length) return null
  return (
    <div className="steps">
      {steps.slice(0, 8).map((s, i) => (
        <div className="step" key={i}>
          <strong>
            {i + 1}. {s.type || 'act'}
          </strong>
          {stepLabel(s)}
        </div>
      ))}
    </div>
  )
}
